import { compact } from "lodash";

export const CustomOAuthInstallAppFilePath = "routes/shopify/GET-install.js";
export const DefaultOAuthAppURLPath = "api/shopify/install-or-render";
export const DefaultWebhookPath = "api/webhooks/shopify";
export const DefaultOAuthCallbackPath = "api/connections/auth/shopify/callback";

export const getDefaultOAuthAppURL = (appDomain: string) => {
  const fullUrl = appDomain.startsWith("http") ? appDomain : `https://${appDomain}`;

  return new URL(DefaultOAuthAppURLPath, fullUrl).toString();
};

export const getDefaultShopifyRedirectUrl = (appDomain?: string) => {
  let appCallback: URL | undefined;

  if (appDomain) {
    const fullUrl = appDomain.startsWith("http") ? appDomain : `https://${appDomain}`;
    appCallback = appDomain ? new URL(DefaultOAuthCallbackPath, fullUrl) : undefined;
  }

  return compact([appCallback]);
};

export const getDefaultWebhookURL = (appDomain: string) => {
  return new URL(DefaultWebhookPath, appDomain).toString();
};
